import { useFormikContext } from 'formik';
import { FC, useState } from 'react';

import { Link, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

interface IUploadButton {
  id: string;
  title: string;
  name: string;
  url?: string;
}

const Input = styled('input')({
  display: 'none',
});

export const UploadButton: FC<IUploadButton> = ({ id, title, name, url }) => {
  const { setFieldValue } = useFormikContext();
  const [text, setText] = useState(title);

  const handleChange = (event: any) => {
    setText(event.target?.files?.[0]?.name);
    setFieldValue(name, event.target.files?.[0]);
  };

  return (
    <Stack direction="row" alignItems="center">
      <label htmlFor={id}>
        <Input
          id={id}
          accept=".pdf,.png,.jpeg,.jpg"
          type="file"
          name={name}
          onChange={(event) => handleChange(event)}
        />
        <Button
          variant="outlined"
          component="span"
          color="inherit"
          sx={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            border: '1.5px solid',
          }}
        >
          adicionar
        </Button>
      </label>
      <Typography
        sx={{
          backgroundColor: '#000',
          color: '#FFFFFF',
          fontSize: 14,
          fontWeight: 700,
          p: 1,
          borderRadius: '0 4px 4px 0',
        }}
      >
        {url ? (
          <Link href={url} target="_blank" color="#FFF">
            {text}
          </Link>
        ) : (
          text
        )}
      </Typography>
    </Stack>
  );
};

